import $ from 'n-zepto';

$(function() {

  // Global
  $(window).on('scroll', function(){
    if ($(window).scrollTop() > 20 ){
      $('header').addClass('shrink');
    } else {
      $('header').removeClass('shrink');
    }
  });

  // Mobile detection

  var isTouchDevice = false;

  $(window).on('touchstart', firstTouch);

  function firstTouch() {
    isTouchDevice = true;
    $(window).off('touchstart', firstTouch);
  }

  window.isMD = false;
  window.isSM = false;

  function detectBreakpoint() {
    if (985 <= window.innerWidth) {
      isMD = false;
      isSM = false;
    } else if  (735 <= window.innerWidth && window.innerWidth < 985) {
      isMD = true;
      isSM = false;
    } else if (window.innerWidth < 735) {
      isMD = false;
      isSM = true;
    }
  }

  $(window).on('resize', detectBreakpoint);
  detectBreakpoint();

  // Mobile menu button

  var $mainNav = $('#main-nav');
  var $userNav = $('#user-nav');

  $('a.user-menu-button').on('click',function(){
    $mainNav.removeClass('expanded');
    $userNav.hasClass('expanded') ? $userNav.removeClass('expanded') : $userNav.addClass('expanded');
  });

  $('a.main-menu-button').on('click',function(){
    $userNav.removeClass('expanded');
    $mainNav.hasClass('expanded') ? $mainNav.removeClass('expanded') : $mainNav.addClass('expanded');
  });

  $('#main-nav a.parent').on('click',function(e){
    if (isSM || isTouchDevice) {
      e.preventDefault();
      $('a.parent').not(this).removeClass('expanded');
      $(this).hasClass('expanded') ? $(this).removeClass('expanded') : $(this).addClass('expanded');
    }
  });

  $('body > *:not(header)').on('click',function(){
    $mainNav.removeClass('expanded');
    $userNav.removeClass('expanded');
    $('a.parent.expanded').removeClass('expanded');
  })

  /*
   * Module - Fade-in
   */
  var $modules = $('.sub-section');

  function modulesAnimation() {
    $modules.each(function(i){
      if (isSkip(this)) {
        skip(this);
      } else if(isFadeIn(this)) {
        fadeIn(this);
        var j = i+1;
        for (; j<$modules.length; j++) {
          if (isFadeIn($modules[j])) {
            (function(j,i){
              $($modules[j]).addClass('fadedInDelay');
              window.setTimeout(function(){
                fadeIn($modules[j]);
              }, (j-i)*250);
            }(j,i));
          } else {
            break;
          }
        }
      }
    });
  }

  function isSkip(module) {
    return !$(module).hasClass('fadedIn') && 
      !$(module).hasClass('fadedInDelay') && 
      ( ($(window).scrollTop()) > $(module).offset().top);
  }

  function isFadeIn(module) {
    return !$(module).hasClass('fadedIn') && 
      !$(module).hasClass('fadedInDelay') && 
      ( ($(window).scrollTop()+$(window).height()+50) > $(module).offset().top);
  }

  function skip(module) {
    $(module).addClass('fadedIn')
  }

  function fadeIn(module) {
    $(module)
      .removeClass('fadedInDelay')
      .addClass('fadedIn')
  }

  modulesAnimation();

  $(window).on('scroll', function(){
     modulesAnimation();
  });

  // User page side menu
  $('.user-sidemenu .has-children').on('click', function(e){
    e.preventDefault();
    if (isMD || isSM || isTouchDevice) {  
      if ($(e.target).parent().hasClass('active-parent')) {
        if ($('.user-sidemenu').hasClass('expand')) {
          $(e.target).next().removeClass('show');  
        } else {
          $(e.target).next().addClass('show');   
        }
      } else {
        $(e.target).next().toggleClass('show');
      }
    } else {
      $('.sub-user-menu').not($(e.target).next()).removeClass('show');
      $(e.target).next().toggleClass('show');
    }

    if (isMD || isSM || isTouchDevice) {
      if($(e.target).next().hasClass('show')) {
        $(e.target).parent().addClass('expand');
      } else {
        $(e.target).parent().removeClass('expand');
      }
      
    }
  });

  $('.user-sidemenu .sub-user-menu a').on('click', function(e){
    e.stopPropagation();
  });

  $('li.active-parent').on('click', function(e){
    e.preventDefault();
    $('.user-sidemenu').toggleClass('expand');
  });

  if($('.advertisement-container').length){
    checkCookie();
  }

  $('.close-ad, .advertisement-overlay').on('click', function(){
    setCookie('index-ad','true',1);
  })

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    $('body').removeClass('no-overflow');
    $('.advertisement-container').addClass('ad-hide');
  }

  function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }

  function checkCookie() {
      var indexAd = getCookie("index-ad");
      if (indexAd == "") {
         $('.advertisement-container').removeClass('ad-hide');
         $('body').addClass('no-overflow');
      }
  }
});



// WEBPACK FOOTER //
// app/javascript/src/javascripts/common/global.js